<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-4">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ titleKey | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>

  <div
    xemexFilesDrop
    [acceptedTypes]="acceptedTypes"
    (dropped)="onFileDrop($event)"
    class="border-2 border-dashed border-primary pt-3 pb-6 rounded-3xl flex flex-col items-center"
  >
    <mat-icon class="text-primary text-[124px] !h-[124px] !w-[124px] mb-3">cloud_upload</mat-icon>
    <div class="text-xl text-primary mb-2">
      {{ 'creation.step1.dragAndDrop' | translate }}
    </div>
    <div class="text-xl text-primary">
      {{ 'creation.step1.or' | translate }}
    </div>
    <button mat-button type="button" class="mb-6" (click)="fileSelect.click()">
      {{ 'creation.step1.browserUpload' | translate }}
    </button>
    <div class="text-body font-light text-primary">
      {{ descriptionKey | translate }}
    </div>
    <input
      type="file"
      accept="{{ acceptedTypes.join(', ') }}"
      (change)="onFileSelected($event)"
      #fileSelect
      [hidden]="true"
    />
  </div>

  <div class="flex justify-end items-center gap-4">
    <button mat-stroked-button color="secondary" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </button>
  </div>
</div>
